export const state = {
    loggedIn: false,
    errorMsg: '',
    userEmail: '',
    userLevel: ''
}